import { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { getYesNoSurveyResults } from '../../services/survey_services';
import { useAccount } from '../../contexts/Account';

const styles = {
  percentageText: {
    fontWeight: '600',
    fontSize: '18px',
  },
  countText: {
    fontWeight: '400',
    fontSize: '16px',
  },
};

export default function SurveyStats({ surveyId }) {
  const [yesNoSurveyResults, setYesNoSurveyResults] = useState({
    yesPercentage: 0,
    yesCount: 0,
    noPercentage: 0,
    noCount: 0,
  });
  const [loadingResults, setLoadingResults] = useState(true);
  const { accountDetails } = useAccount();

  useEffect(async () => {
    let isMounted = true;
    const response = await getYesNoSurveyResults({
      COMPANY_ID: accountDetails.id,
      SURVEY_ID: surveyId,
    });
    if (
      response &&
      response.data &&
      response.data.getYesNoSurveyResults &&
      isMounted
    ) {
      setYesNoSurveyResults(response.data.getYesNoSurveyResults);
    }

    setLoadingResults(false);

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Box sx={{ height: '100%' }}>
      <Box sx={{ width: '100%' }}>
        <Box display={'flex'} justifyContent="space-between" mt={2}>
          <Typography sx={styles.percentageText}>Yes</Typography>
          <Typography sx={styles.percentageText}>
            {yesNoSurveyResults.yesPercentage}%{' '}
            <span style={styles.countText}>
              ({yesNoSurveyResults.yesCount})
            </span>
          </Typography>
        </Box>
        <LinearProgress
          variant={loadingResults ? 'indeterminate' : 'determinate'}
          value={yesNoSurveyResults.yesPercentage}
          sx={{
            height: '12px',
            borderRadius: '6px',
            backgroundColor: '#E0E0E0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#2B71F6',
            },
          }}
        />
      </Box>
      <Box sx={{ width: '100%' }}>
        <Box display={'flex'} justifyContent="space-between" mt={2}>
          <Typography sx={styles.percentageText}>No</Typography>
          <Typography sx={styles.percentageText}>
            {yesNoSurveyResults.noPercentage}%{' '}
            <span style={styles.countText}>({yesNoSurveyResults.noCount})</span>
          </Typography>
        </Box>
        <LinearProgress
          variant={loadingResults ? 'indeterminate' : 'determinate'}
          value={yesNoSurveyResults.noPercentage}
          sx={{
            height: '12px',
            borderRadius: '6px',
            backgroundColor: '#E0E0E0',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#4FB5F9',
            },
          }}
        />
      </Box>
    </Box>
  );
}
